export const contactUsBannerContent = (
    <div className='text-2xl'>
      Contact Us
    </div>
  )